import React from "react";
import BoolInput from "../../input/bool-input";

const Toggle1Widget = ({ widget, onValueUpdate }) => {
  const handleValueUpdate = (data) => {
    const updatedWidget = { ...widget, value: data.toString() };
    onValueUpdate(updatedWidget);
  };

  return (
    <div className="flex items-center h-full w-full">
      {widget && <BoolInput valueSpec={widget} onChange={handleValueUpdate} />}
    </div>
  );
};

export default Toggle1Widget;
